import { createSlice } from '@reduxjs/toolkit';
import { catalogManageOrderStatusType } from './catalogAsyncThunk';

const catalogManageOrderStatusTypeSlice = createSlice({
  name: "catalog",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFail: false,
  },
  reducers: {},
  extraReducers: {
    [catalogManageOrderStatusType.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFail = false;
    },
    [catalogManageOrderStatusType.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
    },
    [catalogManageOrderStatusType.rejected]: (state, action) => {
      state.isLoading = false;
      state.isFail = true;
    },
  },
});

export default catalogManageOrderStatusTypeSlice.reducer;